import { SxProps } from '@mui/system'
import { fontSizes } from '../Components/Common/Typography/TypographyStyles'

// Define the dialog title styles
const dialogTitleStyles: Record<string, SxProps> = {
  root: {
    fontSize: fontSizes.size20,
    fontWeight: 'bold',
  },
}

// Export it
export const dialogStyles: Record<string, SxProps> = {
  title: dialogTitleStyles.root,
}
